import React, { useEffect, useState } from 'react'
import MainContent from './MainContent'
import Header from './Header'
import SideBar from './SideBar'
import { useParams } from 'react-router-dom';
import coursesService from '../../services/coursesService';

function LessonPage() {
  const { courseId, id } = useParams();
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fonction pour récupérer les détails du cours
  const fetchCourseDetails = async (courseId) => {
    try {
      setLoading(true);
      const data = await coursesService.getCourseById(courseId);
      const courseData = data?.id ? data : (data?.data ?? null);
      if (courseData) {
        setCourse(courseData);
      } else {
        setError('Cours non trouvé');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
      console.error('Erreur:', err);
    }
  };

  useEffect(() => {
    if (courseId) {
      fetchCourseDetails(courseId);
    }
  }, [courseId]);

  useEffect(() => {
    if (course) {
      setLoading(false);
    }
  }, [course]);

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="text-red-500 dark:text-red-400">{error}</div>
      </div>
    );
  }

  if (!course) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="text-gray-600 dark:text-gray-300">Cours non trouvé</div>
      </div>
    );
  }

  return (
    <div className="pt-16 md:pt-[92px] flex flex-col min-h-screen font-sans">
      <Header courseTitle={course.title} />

      <div className="flex flex-col lg:flex-row justify-between items-start bg-white">
        <SideBar course={course} />
        <MainContent lessonId={id} />
      </div>
    </div>
  )
}

export default LessonPage